import { ICommand, RelayCommand } from "Application";
import { FieldType, KeyValuePair } from "@shoothill/core";
import moment from "moment";

import { AddStudentViewModel } from "../AddStudentViewModel";
import { AddStudentModel } from "../AddStudentModel";
import { WeeklyRotaDetailsViewModel } from "../../WeeklyRotaDetailViewModel";

export class CommandsManager {
    constructor(private viewModel: AddStudentViewModel) {}

    // ─── Field update commands ────────────────────────────────────────────────

    public updateStudentOptionCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        this.updateField("selectedStudentId", kvp.key);
        const student = this.viewModel.model.students.find((obj: any) => obj.id === kvp.key);
        if (student && student.studentAddresses.length === 1) {
            const addr = student.studentAddresses[0];
            this.updateField("pickUpAddressId", addr.id);
            this.updateField("dropOffAddressId", addr.id);
        }
    });

    /**
     * Selects a student and pre-fills session times from the student's timetable.
     * Requires parentViewModel to read sessionKey and studentList.
     */
    public updateStudentWithPreFillCommand(parentViewModel: WeeklyRotaDetailsViewModel): ICommand {
        return new RelayCommand((kvp: KeyValuePair) => {
            this.updateStudentOptionCommand.execute(kvp);
            const times = this.viewModel.managers.domain.getPreFilledTimesForStudent(kvp.key as string, parentViewModel.sessionKey, parentViewModel.model.studentList as any[]);
            this.viewModel.model.setValue("startTime", times.startTime);
            this.viewModel.model.setValue("endTime", times.endTime);
        });
    }

    public updatePickupAddressCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        this.updateField("pickUpAddressId", kvp.key);
    });

    public updateDropOffAddressCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        this.updateField("dropOffAddressId", kvp.key);
    });

    public updateStartTimeCommand: ICommand = new RelayCommand((value: string) => {
        this.updateField("startTime", moment(new Date(value)).format("HH:mm"));
    });

    public updateEndTimeCommand: ICommand = new RelayCommand((value: string) => {
        this.updateField("endTime", moment(new Date(value)).format("HH:mm"));
    });

    // ─── Form action commands ─────────────────────────────────────────────────

    /**
     * Saves the add-student form.
     * Requires a reference to the parent ViewModel and an onSuccess callback.
     */
    public saveMentorStudentCommand(parentViewModel: WeeklyRotaDetailsViewModel, onSuccess: () => void): ICommand {
        return new RelayCommand(
            async () => {
                await this.viewModel.managers.api.saveMentorStudent(parentViewModel, onSuccess);
            },
            () => !this.viewModel.managers.api.apiClient.IsBusy,
        );
    }

    public closeCommand(onCancel: () => void): ICommand {
        return new RelayCommand(() => {
            onCancel();
            this.viewModel.model.reset();
            this.viewModel.removeError();
        });
    }

    // ─── Private helpers ──────────────────────────────────────────────────────

    private updateField(fieldName: keyof FieldType<AddStudentModel>, value: any): void {
        this.viewModel.setValue(fieldName, value);
        this.viewModel.isFieldValid(fieldName);
    }
}
